import styled from 'styled-components';

export const Bar = styled.div`
  width: 100%;
  height: 66px;
  background-color: #dbb7ff;
  border-top: 2px solid #000;
  border-bottom: 2px solid #000;
`;
